export default __webpack_public_path__ + "mini-icon-ios-26@2x.png";